// extracted by mini-css-extract-plugin
export default {"_":"Contact____WI22M","bubble":"Contact_bubble__JQWRC"};